import { Link } from "react-router-dom";
import { useSettings } from "@/lib/site";
import { OutLink } from "@/components/site/Bits";
import { NAV } from "@/components/GroupHeader";
import { openCookiePreferences } from "@/components/CookieBanner";

const LOGO = "/verde2050-logo-silver.png";

const LEGAL = [
    { label: "Privacy policy", to: "/legal/privacy" },
    { label: "Cookies", to: "/legal/cookies" },
    { label: "Terms", to: "/legal/terms" },
    { label: "Important information", to: "/legal/important-information" },
];

function Ext({ href, label, event, testid, tbc }) {
    if (!href) return <li className="text-cream/45 text-sm" data-testid={testid}>{label} <span className="font-mono text-[10px] uppercase">· link TBC</span></li>;
    return (
        <li>
            <OutLink href={href} event={event} label={label} testid={testid} className="text-sm text-cream/80 hover:text-sage transition-colors">
                {label}
            </OutLink>
        </li>
    );
}

export default function GroupFooter() {
    const s = useSettings();
    return (
        <footer data-testid="site-footer" className="bg-forest text-cream pt-24 md:pt-32 pb-12">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-14 pb-20 border-b border-cream/10">
                    <div className="md:col-span-5">
                        <img src={LOGO} alt="Verde 2050" className="h-[22px] md:h-[26px] w-auto object-contain mb-8" />
                        <p className="font-serif text-2xl md:text-3xl leading-none">Built for <em className="italic text-sage">Tomorrow.</em></p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="mono-label text-sage mb-6">Explore</p>
                        <ul className="space-y-3">
                            {NAV.map((n) => (
                                <li key={n.to}>
                                    <Link to={n.to} data-testid={`footer-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-cream/80 hover:text-sage transition-colors">{n.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-4">
                        <p className="mono-label text-sage mb-6">Network</p>
                        <ul className="space-y-3">
                            <Ext href={s.verde_capital_url} label="Verde Capital" event="verde_capital_click" testid="footer-verde-capital" />
                            <Ext href={s.taylor_brokers_url} label="Taylor Brokers" event="taylor_brokers_click" testid="footer-taylor-brokers" />
                            <Ext href={s.instagram_url} label="Walk the Land" event="instagram_click" testid="footer-instagram" />
                            <Ext href={s.news_url} label="Get The Plot" event="news_click" testid="footer-get-the-plot" />
                            <Ext href={s.linkedin_url} label="LinkedIn" event="linkedin_click" testid="footer-linkedin" />
                        </ul>
                    </div>
                </div>

                <div className="pt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                    <ul className="flex flex-wrap gap-x-6 gap-y-3 text-xs text-cream/60">
                        {LEGAL.map((l) => (
                            <li key={l.to}><Link to={l.to} className="hover:text-cream transition-colors">{l.label}</Link></li>
                        ))}
                        <li>
                            <button type="button" onClick={openCookiePreferences} data-testid="footer-cookie-preferences" className="hover:text-cream transition-colors">
                                Cookie preferences
                            </button>
                        </li>
                    </ul>
                    <p className="text-xs text-cream/50">© {new Date().getFullYear()} Verde 2050</p>
                </div>
                <p className="mt-8 text-xs text-cream/50 leading-relaxed max-w-4xl">
                    Nothing on this website is an offer of securities or investment advice. Co-investment participation is subject to eligibility, documentation and applicable regulation. Residential brokerage is carried out by Taylor Brokers; financing by Verde Capital, a separate business.
                </p>
            </div>
        </footer>
    );
}
